import IComponent from "components/commons/IComponent";
import "./GPTools.scoped.css";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import { Button, Checkbox, Modal } from "@material-ui/core";
import React from "react";
import ReactDOM from "react-dom/client";
import { createPortal } from "react-dom";
import DialogPanel from "components/DialogPanel";
import DrawTool from "components/commons/DrawTool";
import { findAllByDisplayValue } from "@testing-library/react";
import FeatureSet from "@arcgis/core/rest/support/FeatureSet.js";
import * as geometryEngineAsync from "@arcgis/core/geometry/geometryEngineAsync.js";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import { LaptopWindowsTwoTone } from "@material-ui/icons";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import { Divider } from "@material-ui/core";
import DivTable from "components/commons/DivTable";
import geometryTools from "utils/geometryTools";
import * as query from "@arcgis/core/rest/query.js";
import config_zoomto from "components/ZoomTo/config_zoomto";
import GetArcGISToken from "utils/GetArcGISToken";
import ReactECharts from "echarts-for-react";
import "echarts-gl";
import MiniPanel from "components/commons/MiniPanel";
import SwitchButton from "components/commons/SwitchButton";
// let data = [{ REF: "GCME 3/5/4076/11", Division: "District" }];
let extentWatcher = undefined;
let getGround3DConfig = (data) => {
  let maxX = Math.max.apply(null, data.map((i) => i[0]));
  let maxY = Math.max.apply(null, data.map((i) => i[1]));
  let minX = Math.min.apply(null, data.map((i) => i[0]));
  let minY = Math.min.apply(null, data.map((i) => i[1]));

  let maxDistance = Math.max(maxX - minX, maxY - minY);
  let adjustX = (maxDistance - (maxX - minX)) / 2;
  let adjustY = (maxDistance - (maxY - minY)) / 2;

  maxX += adjustX;
  maxY += adjustY;
  minX -= adjustX;
  minY -= adjustY;

  return {
    tooltip: {},
    toolbar: {},
    grid3D: {},
    xAxis3D: {
      type: "value",
      min: (value, a) => (
        (a = minX), (a -= a % 50), console.debug(value, a), a
      ),
      max: (value, a) => (
        (a = maxX), (a += 50 - (a % 50)), console.debug(value, a), a
      ),
      axisLabel: {
        formatter: function(value, index) {
          return (value / 1000).toFixed(2) + "K";
        },
      },
    },
    yAxis3D: {
      type: "value",
      min: (value, a) => (
        (a = minY), (a -= a % 50), console.debug(value, a), a
      ),
      max: (value, a) => (
        (a = maxY), (a += 50 - (a % 50)), console.debug(value, a), a
      ),
      axisLabel: {
        formatter: function(value, index) {
          return (value / 1000).toFixed(2) + "K";
        },
      },
    },
    zAxis3D: {
      type: "value",
      min: (value, a) => (
        (a = Math.round(value.min)), (a -= a % 10), console.debug(value, a), a
      ),
      max: (value, a) => (
        (a = Math.round(value.max)),
        (a += 10 - (a % 10)),
        console.debug(value, a),
        a
      ),
    },
    dataset: {
      dimensions: ["x", "y", "z"],
      source: data,
    },
    series: [
      {
        type: "scatter3D",
        symbolSize: 1.5,
        encode: {
          x: "x",
          y: "y Expectancy",
          z: "z",
          tooltip: [0, 1, 2],
        },
      },
    ],
  };
};
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDialogPanel: false,
      feature: true,
      HLC: false,
      GI: false,
      GIBuffer: false,
      params: undefined,
      searchInput: {
        bufferSize: 0.3,
        GIstations_bufferSize: 0,
        AGS_bufferSize: 10,
      },
      Current: undefined,
      Disabled: false,
      SingleBtn_action: false,
      Enable: false,
      data: undefined,
      extent: undefined,
      overMaximum: false,
      userGroup: undefined,
      GroundSegment: undefined,
      Ground3DSampleSize: 5000,
    };
  }
  componentDidMount() {
    let userGroup = GetArcGISToken.user.userGroup;
    this.setState({ userGroup: userGroup });
  }
  componentDidUpdate(prevProp, prevState) {
    // if (prevProp.mapView != this.props.mapView) {
  }
  componentWillUnmount() {
    if (this.state.Enable) {
      extentWatcher.remove();
      // geometryTools.clearGraphicsByLayerId(
      //   "highlightLayerForGIDrillhole",
      //   this.props.mapView.map
      // );
    }
  }
  async callAsyncGpServiceExample() {
    let url = "https://www.example.com/TestGPServer";
    let params = {
      paras1: "Test",
      paras2: "Test Parameter",
    };
    let options = {
      userProxy: this.$config.useEsriProxy,
    };
    let result = await geoprocessor.execute(url, params, undefined, options);
    // Get the result with either fetchResultData(), fetchResultImage(), or fetchResultMapImageLayer();
    result.fetchResultData();
    result.fetchResultImage();
    result.fetchResultMapImageLayer();
  }

  async DownloadFeaturesWithinPolygon(
    geometry,
    type,
    GroundSegment = undefined
  ) {
    let category =
      type === "Download"
        ? "feature nos"
        : type === "LiDAR"
        ? "LiDAR points"
        : type === "Spot"
        ? "Spot Elevation"
        : type === "Ground"
        ? "Ground Profile"
        : type === "AGS"
        ? "AGS Data"
        : "";

    let DrawType =
      type === "Download" || type === "LiDAR"
        ? "esriGeometryPolygon"
        : type === "Ground" || type === "AGS"
        ? "esriGeometryPolyline"
        : type === "Spot"
        ? "esriGeometryPoint"
        : "";
    let ProcessType =
      type === "Download" || type === "LiDAR"
        ? // || type === "Ground"
          "Async"
        : type === "Spot" || type === "Ground" || type === "AGS"
        ? ""
        : "Sync";

    let UIType =
      type === "Download" || type === "LiDAR" ? "Dialog" : "PanelBase";
    try {
      let feature = this.state.feature ? "feature;" : "";
      let HLC = this.state.HLC ? "HLC;" : "";
      let GI = this.state.GI ? "borehole" : "";
      let url =
        type === "Download"
          ? this.$config.gpToolUrls.SelectAndDownload
          : type === "LiDAR"
          ? this.$config.gpToolUrls.ClipLiDAR
          : "";

      let rings =
        type === "Download" || type === "LiDAR"
          ? geometry.rings.flat().reduce((p, c, i) => {
              p.push([c[0], c[1]]);
              return p;
            }, [])
          : type === "Ground" || type === "AGS"
          ? geometry.paths.flat().reduce((p, c, i) => {
              p.push([c[0], c[1]]);
              return p;
            }, [])
          : [geometry.x, geometry.y];
      let Json =
        type === "Ground" || type === "AGS"
          ? {
              displayFieldName: "",
              // hasZ: true,
              // hasM: true,
              geometryType: "esriGeometryPolyline",
              spatialReference: {
                // wkid: 102140,
                // latestWkid: 102140,
                wkid: 2326,
                latestWkid: 102140,
              },
              fields: [
                {
                  name: "FID",
                  type: "esriFieldTypeOID",
                  alias: "FID",
                },
                {
                  name: "Id",
                  type: "esriFieldTypeInteger",
                  alias: "Id",
                },
                {
                  name: "Z_Min",
                  type: "esriFieldTypeDouble",
                  alias: "Z_Min",
                },
                {
                  name: "Z_Max",
                  type: "esriFieldTypeDouble",
                  alias: "Z_Max",
                },
                {
                  name: "Z_Mean",
                  type: "esriFieldTypeDouble",
                  alias: "Z_Mean",
                },
                {
                  name: "SLength",
                  type: "esriFieldTypeDouble",
                  alias: "SLength",
                },
                {
                  name: "Avg_Slope",
                  type: "esriFieldTypeDouble",
                  alias: "Avg_Slope",
                },
                {
                  name: "Shape_Length",
                  type: "esriFieldTypeDouble",
                  alias: "Shape_Length",
                },
              ],
              features: [{ geometry: { paths: [rings] } }],
              exceededTransferLimit: false,
            }
          : {
              displayFieldName: "",
              geometryType: DrawType,
              spatialReference: {
                wkid: 102140,
                latestWkid: 2326,
              },
              fields: [
                {
                  name: "OBJECTID",
                  type: "esriFieldTypeOID",
                  alias: "OBJECTID",
                },
                {
                  name: "SHAPE_Length",
                  type: "esriFieldTypeDouble",
                  alias: "SHAPE_Length",
                },
                {
                  name: "SHAPE_Area",
                  type: "esriFieldTypeDouble",
                  alias: "SHAPE_Area",
                },
              ],
              features:
                type === "Download" || type === "LiDAR"
                  ? [{ geometry: { rings: [rings] } }]
                  : type === "Spot"
                  ? [{ geometry: { x: rings[0], y: rings[1] } }]
                  : // : type === "Ground"
                    // ? [{ geometry: { paths: [rings] } }]
                    "",
              exceededTransferLimit: false,
            };

      let Processing_Json = FeatureSet.fromJSON(Json);

      let params =
        type === "Download"
          ? {
              Area_of_Interest: Processing_Json,
              Layers: feature + HLC + GI,
              Query: ";;",
            }
          : type === "LiDAR"
          ? { Clip_Polygon: Processing_Json }
          : type === "Spot"
          ? { input_point: Processing_Json }
          : type === "Ground"
          ? {
              DrawLine: Processing_Json,
              Buffer_Distance: {
                distance: this.state.searchInput.bufferSize, //parseFloat(this.state.searchInput.bufferSize),
                units: "esriMeters",
              },
            }
          : type === "AGS"
          ? {
              DrawLine: Processing_Json,
              Buffer_Distance: {
                distance: this.state.searchInput.AGS_bufferSize,
                units: "esriMeters",
              },
            }
          : {};

      let options = {
        userProxy: this.$config.useEsriProxy,
      };

      let result =
        ProcessType === "Async"
          ? await geoprocessor.submitJob(url, params, undefined, options)
          : ProcessType === "Sync"
          ? await geoprocessor.execute(url, params, undefined, options)
          : undefined;

      this.props.showDialog({
        isOpen: true,
        title: "Loading",
        content: (
          <div>
            <span className="icn_loading" />
            Submit your {category}, please wait...
          </div>
        ),
        onDialogCancel: async () => {
          (type === "Download" || type === "LiDAR") &&
            (await result.cancelJob(result.jobId));
        },
      });

      let processR =
        ProcessType === "Async"
          ? await result.waitForJobCompletion()
          : ProcessType === "Sync"
          ? result
          : undefined;

      let Output_File, split_records;

      if (type === "Download") {
        Output_File = await processR.fetchResultData("Output_File");
        let No_of_records = await processR.fetchResultData("No_of_records");
        split_records = No_of_records.value.split(";");
      } else if (type === "LiDAR") {
        Output_File = await processR.fetchResultData("outputZipFile");
      }

      if (UIType === "Dialog") {
        this.props.showDialog({
          isOpen: true,
          title: `Download ${category} below`, //Download ClipLiDAR file below
          content: (
            <div>
              <div style={{ display: "flex" }}>
                <p>Download file: </p>
                <p>&nbsp;</p>
                <p>
                  {!!Output_File.value ? (
                    <a href={Output_File.value.url} target="_blank">
                      {category} file (zip)
                    </a>
                  ) : (
                    <span> &nbsp;/ </span>
                  )}
                </p>
              </div>
              {type === "Download" ? (
                <p>
                  No. of feature polygon -
                  {split_records[0] + split_records[1] + split_records[2] > 0
                    ? ` features:  ${split_records[0]}; HLC: ${
                        split_records[1]
                      }; GI: ${split_records[2]}`
                    : " No Record"}
                </p>
              ) : (
                <></>
              )}
            </div>
          ),
          onDialogOk: () => {},
        });
      } else {
        this.props.showDialog({
          isOpen: false,
        });

        if (type === "Spot") {
          this.setState({
            showDialogPanel: true,
            dialogPanelTitle: "SpotElevations",
            params: params,
          });
        } else if (type === "Ground") {
          let GI_params = {
            DrawLine: Processing_Json,
            Buffer_Distance: {
              distance: this.state.searchInput.GIstations_bufferSize,
              units: "esriMeters",
            },
          };

          this.setState({
            showDialogPanel: true,
            dialogPanelTitle: "GroundProfile",
            params: [params, GI_params, GroundSegment],
          });
        } else if (type === "AGS") {
          //ground profile - output table
          let GP_params = {
            DrawLine: Processing_Json,
            Buffer_Distance: {
              distance: 0.3,
              units: "esriMeters",
            },
          };
          this.setState({
            showDialogPanel: true,
            dialogPanelTitle: "GroundProfileAGS",
            params: [GP_params, params, GroundSegment],
          });
        }
      }
    } catch (e) {
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Failed to submit your " + { category },
        content: "Error occurred when submiting your " + { category },
        jsxElement: e.toString(),
        onDialogOk: () => {},
      });
    }
  }

  async View3DGroundSurface(geometry) {
    let url =
      this.$config.serverUrl +
      "/rest/services/GPTools/Scatter3D/GPServer/ExportScatterXYZ";
    geometry = geometry.toJSON();
    geometry.rings[0].forEach((i) => i.pop());
    delete geometry.hasZ;
    console.debug(geometry);
    let params = {
      "env:outSR": 2326,
      Clip_Polygon: FeatureSet.fromJSON({
        displayFieldName: "",
        geometryType: "esriGeometryPolygon",
        spatialReference: {
          wkid: 102140,
          latestWkid: 2326,
        },
        fields: [],
        features: [{ geometry }],
        exceededTransferLimit: false,
      }),
      Records_Process: this.state.Ground3DSampleSize,
    };
    let options = {
      userProxy: this.$config.useEsriProxy,
    };

    let result = await geoprocessor.submitJob(url, params, undefined, options);
    this.props.showDialog({
      isOpen: true,
      title: "Loading",
      content: (
        <div>
          <span className="icn_loading" />
          Getting the 3D Ground Surface data, please wait...
        </div>
      ),
      onDialogCancel: () => result.cancelJob(result.jobId),
    });
    await result.waitForJobCompletion();
    try {
      let ground3DData = await result.fetchResultData("outputXYZ");
      ground3DData = ground3DData.value.features.map((i) => [
        i.attributes.x,
        i.attributes.y,
        i.attributes.z,
      ]);
      console.debug(ground3DData);
      let ground3DWindow = window.open(
        "about:blank",
        undefined,
        "width=800,height=600,popup=1"
      );
      let chkTimer = setInterval(() => {
        if (ground3DWindow === null) {
          clearInterval(chkTimer);
          this.props.showDialog({
            type: "error",
            isOpen: true,
            title: "Cannot display the result",
            content:
              "Popup window is blocked by the browser! Please allow popup window for this website and try again.",
            onDialogOk: () => {},
          });
        }
        if (
          !!ground3DWindow.document.body &&
          ground3DWindow.document.body.clientHeight > 0
        ) {
          clearInterval(chkTimer);
          ground3DWindow.document.body.style.cssText =
            "margin:0; width:100%;height:100%";
          let container = document.createElement("DIV");
          container.style.cssText = "margin:0; width:100%;height:100%";
          ground3DWindow.document.body.appendChild(container);
          let root = ReactDOM.createRoot(container);
          console.debug(getGround3DConfig(ground3DData));
          let eChartRef = null;
          root.render(
            <ReactECharts
              onChartReady={(chart) => chart.resize()}
              autoResize={true}
              ref={eChartRef}
              style={{ height: "100%" }}
              option={getGround3DConfig(ground3DData)}
            />
          );
        }
      });
      this.props.showDialog({
        isOpen: false,
      });
    } catch (e) {
      this.props.showDialog({
        type: "error",
        isOpen: true,
        title: "Failed to execute the task",
        content: e.toString(),
        onDialogOk: () => {},
      });
    }
  }

  mapUICallback(eventName, para1 = undefined, para2 = undefined) {
    switch (eventName) {
      case "hideAllPanel":
        this.setState({
          Current: undefined,
          showDialogPanel: false,
          Disabled: false,
          SingleBtn_action: false,
        });
        break;
      case "DisableWhenDraw":
        this.setState({
          Current: para1,
          Disabled: para2,
          SingleBtn_action: true,
        });
        break;
      case "clearAll":
        this.setState({
          Current: para1,
          Disabled: para2,
          SingleBtn_action: false,
        });
        break;
      case "DisaleAllWhenShowPanel":
        this.setState({ Current: "DisaleAll" });
        break;
    }
  }

  onChangeHandler(field, value, values) {
    let newState = { ...this.state.searchInput };
    newState[field] = value;
    this.setState({
      searchInput: newState,
    });
  }

  // async highlightGraphic(row, clear = false) {
  async highlightGraphic(row, color = [0, 0, 255, 0.1]) {
    // if (clear) {
    //   geometryTools.clearGraphicsByLayerId(
    //     "highlightLayerForGIDrillhole",
    //     this.props.mapView.map
    //   );
    //   return;
    // }

    let cloneGraphic = new geometryTools.Graphic({
      geometry: row.geometry,
      symbol: geometryTools.highlightSymbol[row.geometry.type],
    });
    cloneGraphic.symbol.color = color; //"#FF0000";
    geometryTools
      .createGraphicsLayerById(
        "highlightLayerForGIDrillhole",
        this.props.mapView.map
      )
      .add(cloneGraphic);
  }

  async querydistrict(newV) {
    let queryPara = {
      outFields: ["*"],
      returnGeometry: true,
      geometry: newV,
    };
    let queryUrl = config_zoomto.TEXUAL_SEARCH_LAYER_URL + "/" + 6;
    let result = await query.executeQueryJSON(queryUrl, queryPara, {
      userProxy: this.$config.useEsriProxy,
    });

    if (result.features.length > 100) {
      this.setState({ overMaximum: true, data: undefined });
    } else {
      geometryTools.clearGraphicsByLayerId(
        "highlightLayerForGIDrillhole",
        this.props.mapView.map
      );
      result.features.map((i) => {
        this.highlightGraphic(i);
      });
      this.setState({
        data: result.features.reduce((p, c, i) => {
          console.log(c.attributes.PROJECT_RE);
          let project_re = c.attributes.PROJECT_RE.trim();
          let erks_re = c.attributes.ERKS_REF.trim();
          let REF = "N/A";
          if (project_re && erks_re)
            REF = (
              <span>
                {project_re}
                <br />
                {erks_re}
              </span>
            );
          else if (project_re || erks_re) REF = project_re || erks_re;
          p[i] = {
            REF,
            Division: "District",
            geometry: c.geometry,
            attributes: c.attributes,
          };
          return p;
        }, []),
        overMaximum: false,
      });
    }
  }

  render() {
    let {
      feature,
      HLC,
      GI,
      GIBuffer,
      Current,
      Disabled,
      SingleBtn_action,
      showDialogPanel,
      Enable,
      data,
      extent,
      overMaximum,
      userGroup,
      GroundSegment,
    } = this.state;
    return (
      <div className="GPToolContainer">
        <div className="PanelTitle">
          <span>Geoprocessing Tools</span>
        </div>
        <div className="GPContentContainer">
          {/* Geoprocess Tools (First section) */}
          <div className="SubPanelContent">
            <div className="EqualWidthChildren">
              <div className="Shrink2">
                <Button
                  className={
                    Current !== undefined &&
                    Current !== "Show" &&
                    (showDialogPanel || SingleBtn_action)
                      ? "GPToolButton Disabled"
                      : "GPToolButton"
                  }
                  onClick={() => {
                    this.setState({
                      showDialogPanel: true,
                      dialogPanelTitle: "Show",
                      Current: "Show",
                      SingleBtn_action: true,
                    });
                  }}
                >
                  <span className="icn_menu_search" />
                </Button>
              </div>
              <span className="GPText">
                Feature distribution in District Councils
              </span>
            </div>
            <div className="EqualWidthChildren">
              <div className="Shrink2">
                <Button
                  className={
                    Current !== undefined &&
                    Current !== "Download" &&
                    (showDialogPanel || SingleBtn_action)
                      ? "GPToolButton Disabled"
                      : "GPToolButton"
                  }
                  onClick={() => {
                    this.setState({
                      showDialogPanel: true,
                      dialogPanelTitle: "Download",
                      Current: "Download",
                      SingleBtn_action: true,
                    });
                  }}
                >
                  <span className="icn_3d_Elevationprofile_export" />
                </Button>
              </div>
              <span className="GPText">
                Download feature polygon by input text
              </span>
            </div>
            <div className="EqualWidthChildren">
              <div className="Shrink2">
                <div
                  className={
                    Current !== undefined &&
                    Current !== "Polygon" &&
                    (Disabled === true || SingleBtn_action || showDialogPanel)
                      ? "GPToolButton Disabled"
                      : "GPToolButton"
                  }
                >
                  <DrawTool
                    mapView={this.props.mapView}
                    onDrawComplete={async (geometry) => {
                      // this.setState({ Current: undefined, Disabled: false });
                      if (!!geometry) {
                        const area = geometryEngine.planarArea(
                          geometry,
                          "hectares"
                        );

                        if (Math.abs(area) > 50) {
                          this.props.showDialog({
                            isOpen: true,
                            type: "error",
                            title: "Area should less than 50 hectares",
                            content:
                              "Please redraw polyon which area is less than 50 hectares",
                            onDialogOk: () => {},
                          });
                        } else {
                          this.DownloadFeaturesWithinPolygon(
                            geometry,
                            "Download"
                          );
                        }
                      }
                    }}
                    excludedList={{ text: 1, polyline: 1, point: 1 }}
                    GPTools="Polygon"
                    mapUICallback={this.mapUICallback.bind(this)}
                  />
                </div>
              </div>
              <span className="GPText">
                Download features within polygon, include:
              </span>
            </div>
            <div className="EqualWidthChildren">
              <div className="Shrink2" />
              <div>
                <label>
                  <Checkbox
                    checked={feature}
                    onClick={() => {
                      if (HLC == false && GI == false) {
                        this.props.showDialog({
                          isOpen: true,
                          type: "error",
                          title: "Please select something to download.",
                          content: "at less tick 1 checkbox",
                          onDialogOk: () => {},
                        });
                      } else {
                        this.setState({ feature: !feature });
                      }
                    }}
                    color="primary"
                  />
                  <span>Feature</span>
                </label>
                <label>
                  <Checkbox
                    checked={HLC}
                    onClick={() => {
                      if (feature == false && GI == false) {
                        this.props.showDialog({
                          isOpen: true,
                          type: "error",
                          title: "Please select something to download.",
                          content: "at less tick 1 checkbox",
                          onDialogOk: () => {},
                        });
                      } else {
                        this.setState({ HLC: !HLC });
                      }
                    }}
                    color="primary"
                  />
                  <span>HLC</span>
                </label>
                <label>
                  <Checkbox
                    checked={GI}
                    onClick={() => {
                      if (feature == false && HLC == false) {
                        this.props.showDialog({
                          isOpen: true,
                          type: "error",
                          title: "Please select something to download.",
                          content: "at less tick 1 checkbox",
                          onDialogOk: () => {},
                        });
                      } else {
                        this.setState({ GI: !GI });
                      }
                    }}
                    color="primary"
                  />
                  <span>GI</span>
                </label>
              </div>
            </div>
            {this.state.showDialogPanel &&
              createPortal(
                <DialogPanel
                  showDialog={this.props.showDialog}
                  is3D={this.props.mapType == 3}
                  mapView={this.props.mapView}
                  title={this.state.dialogPanelTitle}
                  mapUICallback={this.mapUICallback.bind(this)}
                  reduxStore={this.props.reduxStore}
                  reduxCallProxy={this.props.reduxCallProxy}
                  params={this.state.params}
                  GIBuffer={this.state.GIBuffer}
                  enableResize={[
                    "GroundProfile",
                    "GroundProfileAGS",
                    "SpotElevations",
                    "Download",
                  ].includes(this.state.dialogPanelTitle)}
                />,
                document.querySelector(".MainPage")
              )}
          </div>
          {/* LIDAR Data (Second section) */}
          {userGroup !== 4 && (
            <div>
              <div className="" />
              <MiniPanel titleText="LiDAR Data" titleClass="SubPanelTitle">
                <div className="SubPanelContent">
                  <div className="EqualWidthChildren">
                    <div className="Shrink2">
                      <div
                        className={
                          Current !== undefined &&
                          Current !== "Spot" &&
                          (Disabled === true ||
                            SingleBtn_action ||
                            showDialogPanel)
                            ? "GPToolButton Disabled"
                            : "GPToolButton"
                        }
                      >
                        <DrawTool
                          mapView={this.props.mapView}
                          onDrawComplete={async (geometry) => {
                            this.setState({
                              showDialogPanel: false,
                            });
                            if (!!geometry) {
                              this.DownloadFeaturesWithinPolygon(
                                geometry,
                                "Spot"
                              );
                            }
                            //this.mapUICallback("clearAll", undefined, false);
                          }}
                          excludedList={{ text: 1, polyline: 1, polygon: 1 }}
                          GPTools="Spot"
                          mapUICallback={this.mapUICallback.bind(this)}
                        />
                      </div>
                    </div>
                    <span className="GPText">Spot Elevation</span>
                  </div>
                  <div className="EqualWidthChildren">
                    <div className="Shrink2">
                      <div
                        className={
                          Current !== undefined &&
                          Current !== "Ground" &&
                          (Disabled === true ||
                            SingleBtn_action ||
                            showDialogPanel)
                            ? "GPToolButton Disabled"
                            : "GPToolButton"
                        }
                      >
                        <DrawTool
                          mapView={this.props.mapView}
                          onDrawComplete={async (geometry) => {
                            if (!!geometry) {
                              let beforeUpdateGS = [].concat(GroundSegment);
                              let {
                                length,
                                updatedGroundSegment,
                                maxSegmentLength,
                              } = await geometryTools.analysisLineSegment(
                                geometry,
                                beforeUpdateGS
                              );

                              console.log(updatedGroundSegment);
                              GroundSegment = updatedGroundSegment;
                              // this.setState(() => {
                              this.setState({
                                GroundSegment: GroundSegment,
                              });
                              // .toSorted(
                              //   (a, b) => a - b
                              // ),
                              // });

                              console.log("check geo", geometry);
                              let isBufferInvalid =
                                Number(
                                  this.state.searchInput.bufferSize
                                ).toString() === "NaN" ||
                                this.state.searchInput.bufferSize <= 0 ||
                                (GIBuffer &&
                                  (Number(
                                    this.state.searchInput.GIstations_bufferSize
                                  ).toString() === "NaN" ||
                                    this.state.searchInput
                                      .GIstations_bufferSize <= 0));
                              if (
                                length >= 500 ||
                                (GroundSegment.length > 1 &&
                                  maxSegmentLength >= 200) ||
                                isBufferInvalid
                              ) {
                                this.setState({ Current: undefined });
                                this.props.showDialog({
                                  isOpen: true,
                                  type: "error",
                                  title: `${
                                    length >= 500 ||
                                    (GroundSegment.length > 1 &&
                                      maxSegmentLength >= 200)
                                      ? "Please redraw by polyline"
                                      : `Enter your buffer ${
                                          GIBuffer
                                            ? "and GI bufer distance again"
                                            : "distance again"
                                        }`
                                  }`,
                                  content: (
                                    <>
                                      {!isBufferInvalid ? (
                                        GroundSegment.length > 1 &&
                                        maxSegmentLength >= 200 ? (
                                          <div>
                                            Draw your each line Length which is
                                            less than 200m
                                          </div>
                                        ) : (
                                          <div>
                                            Draw your Length which is less than
                                            500m
                                          </div>
                                        )
                                      ) : (
                                        <div>
                                          <div>
                                            Enter buffer{" "}
                                            {GIBuffer
                                              ? "and GI bufer which "
                                              : "which "}
                                            distance {GIBuffer ? "are " : "is "}{" "}
                                            larger than 0
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <div>
                                              Your input in buffer:
                                              {` ${
                                                this.state.searchInput
                                                  .bufferSize
                                              }`}
                                            </div>
                                            {GIBuffer && (
                                              <div>
                                                Your input in GI buffer:
                                                {` ${
                                                  this.state.searchInput
                                                    .GIstations_bufferSize
                                                }`}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  ),
                                  onDialogOk: () => {},
                                });
                              } else {
                                this.DownloadFeaturesWithinPolygon(
                                  geometry,
                                  "Ground",
                                  GroundSegment
                                );
                              }
                            }
                            return true;
                          }}
                          // bufferSize={this.state.searchInput.bufferSize}
                          excludedList={{ text: 1, point: 1, polygon: 1 }}
                          GPTools="Ground"
                          mapUICallback={this.mapUICallback.bind(this)}
                        />
                      </div>
                    </div>
                    <span className="GPText">
                      <div className="EqualWidthChildren">
                        <span> Ground Profile: Buffer:</span>
                        <EditableDatagridCell
                          cellInfo={{
                            colDef: {
                              field: "bufferSize",
                              dataType: "text",
                              values: [],
                              hint: "0.3",
                            },

                            row: this.state.searchInput,
                            key: "graphic_text_01",
                          }}
                          style={{ width: "60px" }}
                          onChange={this.onChangeHandler.bind(this)}
                        />
                        <span className="GPText Shrink2"> m</span>
                      </div>
                    </span>
                  </div>
                  <div className="EqualWidthChildren">
                    <div className="Shrink2" />
                    <div className="EqualWidthChildren">
                      <label>
                        <Checkbox
                          checked={GIBuffer}
                          onClick={() => {
                            this.setState({ GIBuffer: !GIBuffer });
                          }}
                          color="primary"
                        />
                        <span>Inlude GI stations buffer: (m)</span>
                      </label>
                      {GIBuffer && (
                        <EditableDatagridCell
                          cellInfo={{
                            colDef: {
                              field: "GIstations_bufferSize",
                              dataType: "text",
                              values: [],
                              hint: "0.3",
                            },
                            row: this.state.searchInput,
                            key: "graphic_text_01",
                          }}
                          style={{ width: "60px", marginRight: "-10px" }}
                          onChange={this.onChangeHandler.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                  {userGroup !== 3 && (
                    <>
                      <div className="EqualWidthChildren">
                        <div className="Shrink2">
                          <div
                            className={
                              Current !== undefined &&
                              Current !== "LiDAR" &&
                              (Disabled === true ||
                                SingleBtn_action ||
                                showDialogPanel)
                                ? "GPToolButton Disabled"
                                : "GPToolButton"
                            }
                          >
                            <DrawTool
                              mapView={this.props.mapView}
                              onDrawComplete={async (geometry) => {
                                if (!!geometry) {
                                  const area = geometryEngine.planarArea(
                                    geometry,
                                    "hectares"
                                  );

                                  if (Math.abs(area) > 50) {
                                    this.props.showDialog({
                                      isOpen: true,
                                      type: "error",
                                      title:
                                        "Area should less than 50 hectares",
                                      content:
                                        "Please redraw polyon which area is less than 50 hectares",
                                      onDialogOk: () => {},
                                    });
                                  } else {
                                    this.DownloadFeaturesWithinPolygon(
                                      geometry,
                                      "LiDAR"
                                    );
                                  }
                                }
                                this.mapUICallback(
                                  "clearAll",
                                  undefined,
                                  false
                                );
                              }}
                              excludedList={{ text: 1, polyline: 1, point: 1 }}
                              GPTools="LiDAR"
                              mapUICallback={this.mapUICallback.bind(this)}
                            />
                          </div>
                        </div>
                        <span className="GPText">Clip LiDAR Points</span>
                      </div>
                      <div className="EqualWidthChildren">
                        <div className="Shrink2">
                          <div
                            className={
                              Current !== undefined &&
                              Current !== "AGS" &&
                              (Disabled === true ||
                                SingleBtn_action ||
                                showDialogPanel)
                                ? "GPToolButton Disabled"
                                : "GPToolButton"
                            }
                          >
                            <DrawTool
                              mapView={this.props.mapView}
                              onDrawComplete={async (geometry) => {
                                console.log(geometry);
                                if (!!geometry) {
                                  let beforeUpdateGS = [].concat(GroundSegment);
                                  let {
                                    length,
                                    updatedGroundSegment,
                                    maxSegmentLength,
                                  } = await geometryTools.analysisLineSegment(
                                    geometry,
                                    beforeUpdateGS
                                  );

                                  console.log(updatedGroundSegment);
                                  GroundSegment = updatedGroundSegment;
                                  // this.setState(() => {
                                  this.setState({
                                    GroundSegment: GroundSegment,
                                  });
                                  // .toSorted(
                                  //   (a, b) => a - b
                                  // ),
                                  // });

                                  console.log("check geo", geometry);
                                  let isBufferInvalid =
                                    Number(
                                      this.state.searchInput.bufferSize
                                    ).toString() === "NaN" ||
                                    this.state.searchInput.bufferSize <= 0 ||
                                    (Number(
                                      this.state.searchInput.AGS_bufferSize
                                    ).toString() === "NaN" ||
                                      this.state.searchInput.AGS_bufferSize <=
                                        0);
                                  if (
                                    length >= 500 ||
                                    (GroundSegment.length > 1 &&
                                      maxSegmentLength >= 200) ||
                                    isBufferInvalid
                                  ) {
                                    this.setState({ Current: undefined });
                                    this.props.showDialog({
                                      isOpen: true,
                                      type: "error",
                                      title: "Please redraw by polyline",
                                      content: (
                                        <>
                                          {!isBufferInvalid ? (
                                            GroundSegment.length > 1 &&
                                            maxSegmentLength >= 200 ? (
                                              <div>
                                                Draw your each line Length which
                                                is less than 200m
                                              </div>
                                            ) : (
                                              <div>
                                                Draw your Length which is less
                                                than 500m
                                              </div>
                                            )
                                          ) : (
                                            <div>
                                              <div>
                                                Enter buffer distance is larger
                                                than 0
                                              </div>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <div>
                                                  Your input in buffer:
                                                  {` ${
                                                    this.state.searchInput
                                                      .AGS_bufferSize
                                                  }`}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      ),
                                      onDialogOk: () => {},
                                    });
                                  } else {
                                    this.DownloadFeaturesWithinPolygon(
                                      geometry,
                                      "AGS",
                                      GroundSegment
                                    );
                                  }
                                }
                                return true;
                                // this.mapUICallback("clearAll", undefined, false);
                              }}
                              // bufferSize={this.state.searchInput.bufferSize}
                              excludedList={{ text: 1, point: 1, polygon: 1 }}
                              GPTools="AGS"
                              mapUICallback={this.mapUICallback.bind(this)}
                            />
                          </div>
                        </div>
                        <span className="GPText">
                          <div className="EqualWidthChildren">
                            <span> Ground Profile with AGS Data:</span>
                          </div>
                        </span>
                      </div>
                      <div className="EqualWidthChildren">
                        <div className="Shrink2" />
                        <div className="EqualWidthChildren">
                          <span className="Shrink4">Buffer:</span>
                          <EditableDatagridCell
                            cellInfo={{
                              colDef: {
                                field: "AGS_bufferSize",
                                dataType: "text",
                                values: [],
                                hint: "10",
                              },

                              row: this.state.searchInput,
                              key: "graphic_text_01",
                            }}
                            style={{ width: "60px" }}
                            onChange={this.onChangeHandler.bind(this)}
                          />
                          <span className="GPText Shrink2"> m</span>
                        </div>
                      </div>
                      <div className="EqualWidthChildren">
                        <div className="Shrink2">
                          <div
                            className={
                              Current !== undefined &&
                              Current !== "Ground3D" &&
                              (Disabled === true ||
                                SingleBtn_action ||
                                showDialogPanel)
                                ? "GPToolButton Disabled"
                                : "GPToolButton"
                            }
                          >
                            <DrawTool
                              mapView={this.props.mapView}
                              onDrawComplete={async (geometry) => {
                                if (!!geometry) {
                                  const area = geometryEngine.planarArea(
                                    geometry,
                                    "hectares"
                                  );

                                  if (Math.abs(area) > 50) {
                                    this.props.showDialog({
                                      isOpen: true,
                                      type: "error",
                                      title:
                                        "Area should less than 50 hectares",
                                      content:
                                        "Please redraw polyon which area is less than 50 hectares",
                                      onDialogOk: () => {},
                                    });
                                  } else {
                                    this.View3DGroundSurface(geometry);
                                  }
                                }
                                this.mapUICallback(
                                  "clearAll",
                                  undefined,
                                  false
                                );
                              }}
                              excludedList={{ text: 1, polyline: 1, point: 1 }}
                              GPTools="Ground3D"
                              mapUICallback={this.mapUICallback.bind(this)}
                            />
                          </div>
                        </div>
                        <span className="GPText">View 3D Ground Surface</span>
                      </div>
                      <div className="EqualWidthChildren">
                        <div className="Shrink2" />
                        <div className="EqualWidthChildren">
                          <span className="Shrink4">Sample Size</span>
                          <br />
                          <input
                            type="range"
                            min="100"
                            max="20000"
                            value={this.state.Ground3DSampleSize}
                            onChange={(evt) =>
                              this.setState({
                                Ground3DSampleSize: evt.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </MiniPanel>
            </div>
          )}
          {/* Active Contruction Site (last section) */}
          {(userGroup === 1 || userGroup === 2 || userGroup === 8) &&
            GetArcGISToken.user.iu === "g" && (
              <div style={{ height: "100%" }}>
                <MiniPanel
                  removeDefaultClass={true}
                  titleText={
                    <SwitchButton
                      label={
                        <span className="SwitchButtonText">
                          Active Contruction Site (GEO District)
                        </span>
                      }
                      placeAtRight={true}
                      checked={Enable}
                      onClick={() => {
                        let vm = this;
                        Enable = !Enable;
                        if (Enable) {
                          vm.querydistrict(
                            this.props.mapView.extent.expand(0.8)
                          );
                          extentWatcher = this.props.mapView.watch(
                            "stationary",
                            function(newV, oldV) {
                              if (newV)
                                vm.querydistrict(vm.props.mapView.extent);
                            }
                          );
                        } else extentWatcher && extentWatcher.remove();
                        vm.setState({ Enable });
                      }}
                    />
                  }
                  style={{ height: "100%" }}
                  titleClass="SubPanelTitle"
                  collapsed={!Enable}
                >
                  {Enable && (
                    <div className="ActiveSiteTable">
                      <DivTable
                        data={data}
                        columnDef={[
                          {
                            name: "REF",
                            value: "REF",
                            format: (value, row) => (
                              <span
                                className="BookmarkLink"
                                onClick={() => {
                                  // geometryTools.zoomToGraphic(
                                  //   this.props.mapView,
                                  //   [row.geometry]
                                  // );
                                  let url = `https://geointranet.cedd.hksarg/acsis2/Edit.aspx?PROJECTCAT=SSR&PK_ID=${
                                    row.attributes.PROJECTID
                                  }&SEARCH=search`;
                                  window.open(url);
                                }}
                                onMouseOver={() => {
                                  console.log(row);
                                  this.highlightGraphic(row, [255, 0, 0, 0.1]);
                                }}
                                onMouseLeave={() => this.highlightGraphic(row)}
                              >
                                {/^\s*$/.test(value) ? <i>N/A</i> : value}
                              </span>
                            ),
                            width: "70%",
                          },
                          {
                            name: "Division",
                            value: "Division",
                          },
                        ]}
                        noDataText={
                          (overMaximum && (
                            <span style={{ color: "red" }}>
                              More than 100 results found.
                            </span>
                          )) ||
                          (!overMaximum && data?.length === 0 && (
                            <span>No data</span>
                          ))
                        }
                      />
                    </div>
                  )}
                </MiniPanel>
                {/* <div className="Shrink2" /> */}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default ClassName;
